import ReimbursementDetails from "../../../../components/company/expense/reimbursement-claims/ReimburseDetails";

export default function ReimbursementDetailsPage(){
    return <ReimbursementDetails/>
}